import { Main } from '@monorepo/shared/componentsV2/Main';
import {
  contentPadding,
  fillHeightAndScrollable,
  page,
  verticalLayout,
} from '@monorepo/shared/styles/layout';
import styled from 'styled-components';

export const Page = styled.div`
  ${verticalLayout}
  ${page}
`;

export const StyledMain = styled(Main)`
  ${contentPadding}
  ${fillHeightAndScrollable}
`;
